<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane style="min-height: 93vh" :label="$t('Asignar Roles')">
        <el-form label-position="top" :inline="true">
          <el-form-item label="FAENAS" style="margin-bottom: 0px">
            <el-select
              filterable
              @change="setValues"
              v-model="faena_selected"
              size="medium"
              placeholder="Seleccione Faena"
            >
              <el-option
                v-for="item in listadoFaenas"
                :key="item.faena_id"
                :label="item.nombre"
                :value="item.faena_id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Gerencias generales</small>
          </el-form-item>
          <el-form-item label="GERENCIAS GENERALES" style="margin-bottom: 0px">
            <el-select
              filterable
              @change="setGerenciaGeneral"
              v-model="gerencia_general"
              size="medium"
              placeholder="Seleccione Gerencia General"
            >
              <el-option
                v-for="item in gerencias_generales"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Gerencias</small>
          </el-form-item>
          <el-form-item label="GERENCIAS" style="margin-bottom: 0px">
            <el-select
              filterable
              @change="setGerencia"
              v-model="gerencia"
              size="medium"
              placeholder="Seleccione Gerencia"
            >
              <el-option
                v-for="item in gerencias"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Superintendencias</small>
          </el-form-item>
          <el-form-item label="SUPERINTENDENCIA" style="margin-bottom: 0px">
            <el-select
              filterable
              @change="setSuperintendencia"
              v-model="superintendencia"
              size="medium"
              placeholder="Seleccione Superintendencia"
            >
              <el-option
                v-for="item in superintendencias"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Areas</small>
          </el-form-item>
          <el-form-item label="ÁREA" style="margin-bottom: 0px">
            <el-select
              filterable
              @change="setArea"
              v-model="area"
              size="medium"
              placeholder="Seleccione área"
            >
              <el-option
                v-for="item in areas"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Sub-areas</small>
          </el-form-item>
          <el-form-item>
            <br />
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Filtros')"
              width="200"
              trigger="hover"
              :content="
                $t(
                  `Con los filtros usted podrá determinar la faena, la gerencia, la superintendencia y el área que desea asignar, no es obligatorio introducir todos los filtros.`
                )
              "
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
        </el-form>
        <br /><br />
        <small>Incluír sub-contratos</small>
        <el-switch
          style="margin-left: 20px"
          v-model="subcontrato"
          active-text="SI"
          inactive-text="NO"
        >
        </el-switch>
        <br /><br /><br />
        <small><b>SELECCIONE LOS ESPECIALISTAS</b></small>
        <br /><br />
        <el-row :gutter="20">
          <el-col :sm="6">
            <small>Especialista de salud</small><br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="salud.user_1"
              placeholder="Seleccione especialista de salud"
            >
              <el-option
                v-for="item in usuarios.salud"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="salud.user_2"
              placeholder="Seleccione especialista de salud"
            >
              <el-option
                v-for="item in usuarios.salud"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="salud.user_3"
              placeholder="Seleccione especialista de salud"
            >
              <el-option
                v-for="item in usuarios.salud"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="salud.user_4"
              placeholder="Seleccione especialista de salud"
            >
              <el-option
                v-for="item in usuarios.salud"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :sm="6">
            <small>Especialista de seguridad</small><br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="seguridad.user_1"
              placeholder="Seleccione especialista de seguridad"
            >
              <el-option
                v-for="item in usuarios.seguridad"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="seguridad.user_2"
              placeholder="Seleccione especialista de seguridad"
            >
              <el-option
                v-for="item in usuarios.seguridad"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="seguridad.user_3"
              placeholder="Seleccione especialista de seguridad"
            >
              <el-option
                v-for="item in usuarios.seguridad"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="seguridad.user_4"
              placeholder="Seleccione especialista de seguridad"
            >
              <el-option
                v-for="item in usuarios.seguridad"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :sm="6">
            <small>Especialista de medioambiente</small><br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_1"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_2"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_3"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_4"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_5"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_6"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_7"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_8"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_9"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="medioambiente.user_10"
              placeholder="Seleccione especialista de medioambiente"
            >
              <el-option
                v-for="item in usuarios.medioambiente"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :sm="6">
            <small>Especialista de riesgos</small><br />
            <el-select
              filterable
              style="margin-top: 10px; width: 100%"
              v-model="especialista_riesgo.user_1"
              placeholder="Seleccione especialista de riesgos"
            >
              <el-option
                v-for="item in usuarios.especialista_riesgo"
                :key="item._id"
                :label="`${item.nombre} ${item.apellido} (${item.rut})`"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <br />
        <el-button @click="cambiarUsuarios" type="primary" size="md">Continuar</el-button>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      subcontrato: false,
      salud: {
        user_1: "",
        user_2: "",
        user_3: "",
        user_4: "",
      },
      seguridad: {
        user_1: "",
        user_2: "",
        user_3: "",
        user_4: "",
      },
      medioambiente: {
        user_1: "",
        user_2: "",
        user_3: "",
        user_4: "",
        user_5: "",
        user_6: "",
        user_7: "",
        user_8: "",
        user_9: "",
        user_10: "",
      },
      especialista_riesgo: {
        user_1: "",
      },
      area_master: "",
      area_id: "",
      faena_selected: "",
      gerencia_general: "",
      gerencia: "",
      superintendencia: "",
      area: "",
      listadoFaenas: [
        {
          nombre: "SAFETY CLUB",
          faena_id: "5c262b3176851b775b8bdefc",
        },
        {
          nombre: "MEL",
          faena_id: "5a6f78337b772dcfe68241d5",
        },
        {
          nombre: "SPENCE",
          faena_id: "5a6f78417b772dcfe68241e5",
        },
        {
          nombre: "CERRO COLORADO",
          faena_id: "5a6f784e7b772dcfe68241f4",
        },
        {
          nombre: "BHP",
          faena_id: "5b48f15d6f0ed90fc02826e3",
        },
      ],
      gerencias_generales: [],
      gerencias: [],
      superintendencias: [],
      areas: [],
      user: {},
      usuarios: [],
    };
  },
  created() {
    this.$store.dispatch("setSubTitle", "Asignar roles de forma masiva");
    this.user = JSON.parse(JSON.stringify(this.$store.getters.user));
    this.faena_selected = this.$store.getters.role.faena_id;
    this.setValues();
    this.getUsersByRol();
  },
  methods: {
    async cambiarUsuarios() {
      this.$confirm("¿Estas seguro que deseas continuar?", "Advertencia", {
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        type: "warning",
      }).then(async () => {
        const response = await axios.post(
          `/contratos/cambiarUsuarios`,
          {
            faena_id: this.faena_selected,
            area_master: this.area_master,
            subcontrato: this.subcontrato,
            salud: this.salud,
            seguridad: this.seguridad,
            medioambiente: this.medioambiente,
            especialista_riesgo: this.especialista_riesgo,
          },
          this.config()
        );
        if (response.data.success === true) {
          this.$alert(response.data.message, "Información", {
            type: "success",
            confirmButtonText: "Aceptar",
            callback: (action) => {
              window.location.reload();
            },
          });
        }
      });
    },
    config() {
      return {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
    },
    async getUsersByRol() {
      let response = await axios.get(
        `/usuarios/getUsersAsign/${this.faena_selected}`,
        this.config()
      );
      this.usuarios = response.data;
    },
    async setArea() {
      if (this.area === "") {
        this.area_master = this.superintendencia;
      } else {
        this.area_master = this.area;
      }
      this.fecha_selected = "";
    },
    async setSuperintendencia() {
      if (this.superintendencia === "") {
        this.area_master = this.gerencia;
      } else {
        this.area_master = this.superintendencia;
      }
      const response = await axios.post(`/data-science/areasByPadre`, {
        area_padre_id: this.superintendencia,
        faena_id: this.faena_selected,
      });
      this.areas = response.data;
      this.area = "";
      this.fecha_selected = "";
    },
    async setGerencia() {
      if (this.gerencia === "") {
        this.area_master = this.gerencia_general;
      } else {
        this.area_master = this.gerencia;
      }
      const response = await axios.post(`/data-science/areasByPadre`, {
        area_padre_id: this.gerencia,
        faena_id: this.faena_selected,
      });
      this.superintendencias = response.data;
      this.areas = [];
      this.area = "";
      this.superintendencia = "";
      this.fecha_selected = "";
    },
    async setGerenciaGeneral() {
      if (this.gerencia_general === "") {
        this.area_master = "";
      } else {
        this.area_master = this.gerencia_general;
      }
      const response = await axios.post(`/data-science/areasByPadre`, {
        area_padre_id: this.gerencia_general,
        faena_id: this.faena_selected,
      });
      this.gerencias = response.data;
      this.gerencia = "";
      this.superintendencias = [];
      this.areas = [];
      this.area = "";
      this.superintendencia = "";
    },
    async setValues() {
      const response = await axios.post(`/data-science/areasByPadre`, {
        area_padre_id: this.area_id,
        faena_id: this.faena_selected,
      });
      this.getUsersByRol();
      this.area_master = "";
      this.gerencias_generales = response.data;
      this.gerencias = [];
      this.superintendencias = [];
      this.areas = [];
      this.area = "";
      this.superintendencia = "";
      this.gerencia = "";
      this.gerencia_general = "";
    },
  },
};
</script>

<style scoped></style>
